import ModelForPrintingOrderDetails from "./ModelForPrintingOrderDetails";
import { ModelForPrintingCaseDetailsSectionV2 } from "../../Components/Order-Comps/ModelForPrintingCaseDetailsSectionV2";

function ModelForPrintingOrderDetailsV2(props) {
  return <ModelForPrintingOrderDetails {...props} CaseDetailsComponent={ModelForPrintingCaseDetailsSectionV2} />;
}

export default ModelForPrintingOrderDetailsV2;
